// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__36fOd","author":"Table_author__L9wf_","authorImage":"Table_authorImage__1e4az","unreadRow":"Table_unreadRow__UyPvS"};